var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasSeriesData
    ? _c(
        "div",
        {
          staticClass: "vks-assoc-ld-plot",
          class: { "is-stack": _vm.isStacked },
        },
        [
          _vm.isStacked
            ? _vm._l(_vm.plotSeries, function (series) {
                return _c(
                  "div",
                  {
                    key: _vm.seriesKey(series),
                    staticClass: "vks-assoc-ld-stack-item",
                  },
                  [
                    _c("header", { staticClass: "vks-assoc-ld-stack-head" }, [
                      _c(
                        "h4",
                        { staticClass: "vks-assoc-ld-stack-title" },
                        [
                          _vm.multiPhenotype && series.phenotypeLabel
                            ? [
                                _c(
                                  "span",
                                  {
                                    staticClass: "vks-assoc-ld-stack-phenotype",
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(series.phenotypeLabel) + " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "vks-assoc-ld-stack-sep" },
                                  [_vm._v("·")]
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" " + _vm._s(_vm.ancestryTitle(series)) + " "),
                          _c(
                            "span",
                            { staticClass: "vks-assoc-ld-stack-code" },
                            [_vm._v("(" + _vm._s(series.ancestry) + ")")]
                          ),
                        ],
                        2
                      ),
                      _c("span", { staticClass: "vks-assoc-ld-stack-count" }, [
                        _vm._v(
                          " " +
                            _vm._s(series.rows.length.toLocaleString()) +
                            " associations "
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "vks-assoc-ld-panel" },
                      [
                        _vm.plotDataForSeries(series)
                          ? _c("VariantSifterLdRegionPlot", {
                              attrs: {
                                "plot-rows": _vm.plotDataForSeries(series),
                                "search-session": _vm.searchSession,
                                "plot-overlays-state": _vm.plotOverlaysState,
                                "plot-margin": _vm.plotMargin,
                                "plot-markers": _vm.plotMarkers,
                                "highlight-variant-id": _vm.hoveredVariantId,
                                utils: _vm.utils,
                              },
                              on: {
                                "hover-variant": _vm.onHoverVariant,
                                "toggle-star-variant": function ($event) {
                                  return _vm.$emit(
                                    "toggle-star-variant",
                                    $event
                                  )
                                },
                                "set-reference-variant": function ($event) {
                                  return _vm.$emit(
                                    "set-reference-variant",
                                    $event
                                  )
                                },
                              },
                            })
                          : _c("p", { staticClass: "vks-assoc-ld-empty" }, [
                              _vm._v(
                                " No LD points for " +
                                  _vm._s(_vm.seriesDisplayLabel(series)) +
                                  ". "
                              ),
                            ]),
                      ],
                      1
                    ),
                  ]
                )
              })
            : [
                _vm.showTabs
                  ? _c("div", { staticClass: "vks-assoc-ld-tab-bar" }, [
                      _c(
                        "div",
                        {
                          staticClass: "vks-assoc-ld-tabs",
                          attrs: {
                            role: "tablist",
                            "aria-label": "Association LD plots",
                          },
                        },
                        _vm._l(_vm.plotSeries, function (series) {
                          return _c(
                            "button",
                            {
                              key: _vm.seriesKey(series),
                              staticClass: "vks-assoc-ld-tab",
                              class: {
                                "is-active":
                                  _vm.seriesKey(series) === _vm.activeSeriesKey,
                              },
                              attrs: {
                                type: "button",
                                role: "tab",
                                "aria-selected":
                                  _vm.seriesKey(series) === _vm.activeSeriesKey
                                    ? "true"
                                    : "false",
                                title: `${_vm.seriesDisplayLabel(
                                  series
                                )} · ${series.rows.length.toLocaleString()} associations`,
                              },
                              on: {
                                click: function ($event) {
                                  _vm.activeSeriesKey = _vm.seriesKey(series)
                                },
                              },
                            },
                            [
                              _vm.multiPhenotype && series.phenotypeLabel
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "vks-assoc-ld-tab-phenotype",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(series.phenotypeLabel) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "span",
                                { staticClass: "vks-assoc-ld-tab-code" },
                                [_vm._v(_vm._s(series.ancestry))]
                              ),
                              _c(
                                "span",
                                { staticClass: "vks-assoc-ld-tab-label" },
                                [_vm._v(_vm._s(_vm.ancestryTitle(series)))]
                              ),
                              _c(
                                "span",
                                { staticClass: "vks-assoc-ld-tab-count" },
                                [
                                  _vm._v(
                                    _vm._s(series.rows.length.toLocaleString())
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ])
                  : _vm.activeSeries
                  ? _c(
                      "p",
                      { staticClass: "vks-assoc-ld-single-label" },
                      [
                        _vm.multiPhenotype && _vm.activeSeries.phenotypeLabel
                          ? [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.activeSeries.phenotypeLabel) +
                                  " "
                              ),
                              _c(
                                "span",
                                { staticClass: "vks-assoc-ld-stack-sep" },
                                [_vm._v("·")]
                              ),
                            ]
                          : _vm._e(),
                        _vm._v(
                          " " +
                            _vm._s(_vm.ancestryTitle(_vm.activeSeries)) +
                            " "
                        ),
                        _c(
                          "span",
                          { staticClass: "vks-assoc-ld-single-count" },
                          [
                            _vm._v(
                              " (" +
                                _vm._s(
                                  _vm.activeSeries.rows.length.toLocaleString()
                                ) +
                                ") "
                            ),
                          ]
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "vks-assoc-ld-panel",
                    class: { "is-tabbed": _vm.showTabs },
                    attrs: { role: "tabpanel" },
                  },
                  [
                    _vm.activePlotData
                      ? _c("VariantSifterLdRegionPlot", {
                          key: _vm.activeSeriesKey,
                          attrs: {
                            "plot-rows": _vm.activePlotData,
                            "search-session": _vm.searchSession,
                            "plot-overlays-state": _vm.plotOverlaysState,
                            "plot-margin": _vm.plotMargin,
                            "plot-markers": _vm.plotMarkers,
                            "highlight-variant-id": _vm.hoveredVariantId,
                            utils: _vm.utils,
                          },
                          on: {
                            "hover-variant": _vm.onHoverVariant,
                            "toggle-star-variant": function ($event) {
                              return _vm.$emit("toggle-star-variant", $event)
                            },
                            "set-reference-variant": function ($event) {
                              return _vm.$emit("set-reference-variant", $event)
                            },
                          },
                        })
                      : _c("p", { staticClass: "vks-assoc-ld-empty" }, [
                          _vm._v(
                            " No LD points for " +
                              _vm._s(
                                _vm.seriesDisplayLabel(_vm.activeSeries) ||
                                  "this series"
                              ) +
                              ". "
                          ),
                        ]),
                  ],
                  1
                ),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }